import { FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import { withTranslation } from 'react-i18next';
import Bottom from './Bottom';

@inject('commonStore', 'menuStore', 'orderStore')
@observer
class PaymentKPN extends Component {
  componentDidMount() {
    const { orderStore } = this.props;

    // 결제 방법 기본값을 카드로 설정
    if (!orderStore.paymentMethod) {
      orderStore.setPaymentMethod('1');
    }

    const script = document.createElement('script');
    script.src = `${process.env.REACT_APP_KPN_URL}/js/firstpay.js`;
    script.async = true;
    document.body.appendChild(script);
  }

  /** 결제방법 변경 */
  handlePayMethodChange = event => {
    this.props.orderStore.setPaymentMethod(event.target.value);
  };

  /** 결제 진행 */
  pay = async () => {
    const { i18n, commonStore, menuStore, orderStore } = this.props;

    /*global FirstPay*/
    let pay = new FirstPay({
      env: process.env.REACT_APP_ENV === 'production' ? 'product' : 'develop',
      isMobile: isMobile,
      openType: 'submit',
    });

    // 결제페이지 호출
    pay.goPay({
      payMethod: 'CC',
      mxId: menuStore.storeData.merchantID,
      mxIssueNo: orderStore.orderAuthData.orderId,
      mxIssueDate: `${orderStore.orderAuthData.ediDate}${orderStore.orderAuthData.ediTime}`,
      orderName: orderStore.paymentMenuName,
      amount: orderStore.paymentAmount,
      taxAmount: orderStore.paymentAmount - orderStore.orderData.paymentTaxFree, // 과세 결제금액 = 결제금액(paymentAmount) - 면세금액(paymentTaxFree)
      taxFreeAmount: orderStore.orderData.paymentTaxFree,
      returnUrl: `${process.env.REACT_APP_SMARTORDER_API_URL}/sales/kpn/callback?companyId=${commonStore.companyId}&storeCode=${commonStore.storeCode}&isLiteOrder=${orderStore.isLiteOrder}`,
      mallApReserved: `${commonStore.companyId}|${commonStore.storeCode}`,
      callHash: orderStore.orderAuthData.signData,
      lang: i18n.language === 'ko' ? 'ko' : 'en',
    });
  };

  render() {
    const { t, menuStore, orderStore } = this.props;
    return (
      <React.Fragment>
        {/* 결제방법 선택 */}
        {menuStore.storeData.isEzwelPayUsed && (
          <Grid item container direction={'column'} spacing={1} style={{ marginTop: '25px' }}>
            <Grid item>
              <span style={{ fontSize: '13pt', fontWeight: 'bold' }}>{t('payment.label.method')}</span>
            </Grid>
            <Grid item>
              <RadioGroup
                aria-label="gender"
                name="gender1"
                value={orderStore.paymentMethod}
                onChange={this.handlePayMethodChange}
              >
                <FormControlLabel value={1} control={<Radio color="primary" />} label={'일반결제'} />
                <FormControlLabel value={0} control={<Radio color="primary" />} label={'이지웰페이'} />
              </RadioGroup>
            </Grid>
          </Grid>
        )}
        <Bottom pay={this.pay} />
      </React.Fragment>
    );
  }
}

export default withTranslation()(PaymentKPN);
